import React, { useEffect, useState } from 'react';
import { Text, DefaultButton, IPanelStyles, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, IDropdownOption, ISeparator, ISeparatorProps, IBasePickerSuggestionsProps, ITag, ValidationState, Label, TagPicker, IBasePicker } from '@fluentui/react';
import { ILookupField , IChoiceField, IField, IMailbox, IMailboxInUor, IMailboxOutUor, IMailboxUor, IRuoloUor, ITextField, IUor, IUser, IUserField, IUserNotifications } from '../../shared/interfaces';
import DynamicForm from '../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import { RootState } from '../../store';
import { connect, ConnectedProps } from 'react-redux';
import { Indici_FormMode, MailboxUor_Type } from '../../shared/enums';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { toastRef } from '../Layout/Layout';
import mailboxesUorService from '../../services/mailboxesUor.service';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}

const mapState = (state: RootState) => ({

})
const mapDispatch = {

}
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddMailboxProps {
    loading?: boolean
    extraCssClass?: string
    selectedUor?: IUor
    selectedMailbox?: IMailboxUor
    mailboxesList: IMailboxUor[]
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (Mailbox: IMailboxUor) => void
    onDismiss: () => void
}

type Props = AddMailboxProps & RouteComponentProps & PropsFromRedux

const AddMailbox: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [mailboxes, setMailboxes] = useState<IMailbox[]>([]);
    const [mailboxType, setMailboxType] = useState<MailboxUor_Type>(MailboxUor_Type.Udenfined);
    const [typeIsSelected, setTypeIsSelected] = useState<boolean>(false);

    useEffect(() => {
        setFieldsValues();
        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen)
    }, [props.panelIsOpen]);

    //useEffect(() => {
    //    updateFieldsInPanel();
    //}, [typeIsSelected, props.panelIsOpen]);


    const setFieldsValues = () => {

        let tagPickerSuggestionsProps: IBasePickerSuggestionsProps =
        {
            suggestionsHeaderText: 'Suggerimenti',
            mostRecentlyUsedHeaderText: 'Risultati recenti',
            noResultsFoundText: 'Nessun risultato trovato',
            loadingText: 'Caricamento',
            showRemoveButtons: false,
        }

        let inOutField = [
            {
                displayName: "In entrata/In uscita",
                internalName: "mailboxType",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: "",
                valid: false,
                touched: false,
                options: [
                    { text: "In entrata", key: 1 },
                    { text: "In uscita", key: 2 }
                ] as IDropdownOption[]
            } as IChoiceField,
            {
                displayName: "Indirizzo e-mail",
                internalName: "mailboxesUor",
                controlType: "autocomplete",
                required: true,
                readonly: false,
                disabled: true,
                system: false,
                internalValue: [],
                valid: false,
                touched: false
            } as ILookupField 

        ];

        setFields(inOutField);
    }

    const searchSuggestions = async (mailType: MailboxUor_Type, filterText: string, currentTags?: ITag[]): Promise<ITag[]> => {
        let result: ITag[] = [];
        let aooId: number = Number(props.match.params['aooId']);

        if (props.selectedUor && filterText) {
            await mailboxesUorService.getMailboxesSuggestionsForCurrentUor(aooId, props.selectedUor!.id!, filterText, mailType)
                .then(filteredMailboxes => {
                    setMailboxes(filteredMailboxes);
                    result = filteredMailboxes.map((mailbox) => {
                        return {
                            key: mailbox.id,
                            name: mailbox.address
                        }
                    })
                });
        }
        if (currentTags) {
            //Rimuovo eventuali elementi già selezionati
            result = result.filter(tag => currentTags.findIndex(el => el.key === tag.key) < 0);
        }
        return result;
    }

    // Click su salva del panel laterale
    const addMailboxSubmit = () => {

        let mailboxAsITag: ITag = fields.find(el => el.internalName === 'mailboxesUor')?.internalValue[0];
        let mailboxType = fields.find(el => el.internalName === 'mailboxType')?.internalValue === 1 ? MailboxUor_Type.In : MailboxUor_Type.Out;

        if (checkMailboxFormValidity()) {

            let mailboxUorItem: IMailboxUor = {
                mailbox: {
                    id: mailboxAsITag?.key as number,
                    address: mailboxAsITag?.name as string,
                    enabled: true // le cassette che arrivano dai suggerimenti sono sempre abilitate
                },
                mailboxId: mailboxAsITag?.key as number,
                uorId: props.selectedUor!.id!,
                type: mailboxType
            };

            let newMailboxUorItem: IMailboxUor = {
                ...mailboxUorItem
            }
            props.onSubmit(newMailboxUorItem);
            resetFormFields();

        }
    }

    const checkMailboxFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);


        if (newField.internalName === 'mailboxType') {
            //let mailboxType = newField.internalValue === 1 ? MailboxUor_Type.In : MailboxUor_Type.Out;
            let mailboxesUorIndex = updatedFields.findIndex(el => el.internalName === 'mailboxesUor');
            let mailboxesUorField = updatedFields[mailboxesUorIndex] as ILookupField ;
            mailboxesUorField.disabled = !newField.internalValue || newField.internalValue === 0;
            mailboxesUorField.basePickerProps = {
                onResolveSuggestions: (filterText: string, currentTags?: ITag[]) => searchSuggestions(newField.internalValue, filterText, currentTags)
            };
            updatedFields[mailboxesUorIndex] = { ...mailboxesUorField };

        }

        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addMailboxSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <Panel
                key='addMailboxPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />
                <div className={"flex flex-column position-relative overflow-hidden"}>
                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}

                        />


                    </div>
                </div>
                {props.selectedUor && !props.selectedMailbox &&
                    < Text variant={'mediumPlus'} styles={textStyles}>Stai aggiungendo l'indirizzo di posta alla UOR "{props.selectedUor.nome}"</Text>}

            </Panel>
        </React.Fragment>

    );
}

export default connector(withRouter(AddMailbox));
